import { all, call, takeLatest } from 'redux-saga/effects'

import { LOAD_BLOG_DETAIL_PAGE, LOAD_BLOG_LIST_PAGE } from './actions'
import { getBlogPostBySlugService, getBlogPostsService } from './index'

interface LoadBlogListAction {
  type: string
  payload: { req?: unknown }
}

interface LoadBlogDetailAction {
  type: string
  payload: { slug: string; req?: unknown }
}

function* loadBlogListPageSaga({ payload }: LoadBlogListAction): Generator {
  yield call(getBlogPostsService.requestSaga as (args: { payload: { req?: unknown } }) => unknown, {
    payload: { req: payload.req },
  })
}

function* loadBlogDetailPageSaga({ payload }: LoadBlogDetailAction): Generator {
  yield call(
    getBlogPostBySlugService.requestSaga as (args: {
      payload: { urlParams: string; req?: unknown }
    }) => unknown,
    {
      payload: { urlParams: payload.slug, req: payload.req },
    },
  )
}

export default function* saga(): Generator {
  yield all([
    takeLatest(
      LOAD_BLOG_LIST_PAGE,
      loadBlogListPageSaga as (action: LoadBlogListAction) => Generator,
    ),
    takeLatest(
      LOAD_BLOG_DETAIL_PAGE,
      loadBlogDetailPageSaga as (action: LoadBlogDetailAction) => Generator,
    ),
  ])
}
